module.exports = __webpack_public_path__ + "static/media/login-prm-pic2-en.a299eb5b.jpg";